import React, { useMemo, useState } from "react";
import PropTypes from "prop-types";
import { Box, Stack, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import DeleteConfirmModal from "../../common/crud/DeleteConfirmModal";
import EntityTableCard from "../../common/crud/EntityTableCard";
import Pen from "../../assets/images/pen.svg";
import DeleteIMG from "../../assets/images/trash.svg";
import useClients from "../../hooks/store/clients";
import usePermissions from "../../hooks/usePermissions";

export const ClientTable = ({
  count = 0,
  items = [],
  onPageChange = () => {},
  onRowsPerPageChange,
  page = 0,
  rowsPerPage = 10,
  selected = [],
}) => {
  const navigate = useNavigate();
  const { updateClientDataAction } = useClients();
  const { clientId, isClient } = usePermissions();
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [selectedClient, setSelectedClient] = useState(null);
  const hideActions = isClient && clientId;

  const handleDeleteClient = async () => {
    setIsDeleteModalOpen(false);

    await updateClientDataAction({
      id: selectedClient?.id,
      name: selectedClient?.name,
      address: selectedClient?.address,
      email: selectedClient?.email,
      phone: selectedClient?.phone,
      status: "Deactive",
    });
  };

  const columns = useMemo(
    () => [
      {
        id: "serial",
        label: "S.No",
        render: (_, { rowNumber }) => rowNumber,
      },
      {
        id: "client-id",
        key: "id",
        label: "Client Id",
      },
      {
        id: "name",
        label: "Name",
        render: (clientItem) => (
          <Stack alignItems="center" direction="row" spacing={2}>
            <Typography variant="subtitle2">{clientItem.name}</Typography>
          </Stack>
        ),
      },
      {
        id: "email",
        key: "email",
        label: "Email",
      },
      {
        id: "address",
        key: "address",
        label: "Address",
      },
      {
        id: "phone",
        key: "phone",
        label: "Phone Number",
      },
      !hideActions && {
        id: "action",
        label: "Action",
        render: (clientItem) => (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Box
              component="img"
              src={Pen}
              alt="pen"
              onClick={() =>
                navigate("/clients/editclient", {
                  state: { client: clientItem },
                })
              }
              sx={{ cursor: "pointer" }}
            />
            <Box
              component="img"
              src={DeleteIMG}
              alt="DeleteIMG"
              onClick={() => {
                setSelectedClient(clientItem);
                setIsDeleteModalOpen(true);
              }}
              sx={{
                cursor: "pointer",
                height: "20px",
              }}
            />
          </Box>
        ),
      },
    ].filter(Boolean),
    [hideActions, navigate]
  );

  return (
    <>
      <EntityTableCard
        columns={columns}
        count={count}
        items={items}
        onPageChange={onPageChange}
        onRowsPerPageChange={onRowsPerPageChange}
        page={page}
        rowsPerPage={rowsPerPage}
        selected={selected}
      />
      <DeleteConfirmModal
        message=" Are you sure you want to delete this client?"
        onCancel={() => setIsDeleteModalOpen(false)}
        onConfirm={handleDeleteClient}
        open={isDeleteModalOpen}
      />
    </>
  );
};

ClientTable.propTypes = {
  count: PropTypes.number,
  items: PropTypes.array,
  onPageChange: PropTypes.func,
  onRowsPerPageChange: PropTypes.func,
  page: PropTypes.number,
  rowsPerPage: PropTypes.number,
  selected: PropTypes.array,
};
